import store from './index';
export const selectMapProjects = () => store((state) => state.data.features.projects);
export const selectMapClusters = () => store((state) => state.data.features.clusters);
export const selectMapProjectById = (id) => store((state) => state.data.features.projects.find((project) => project.id === id));
export const selectListProjects = () => store((state) => state.data.projects);
export const selectListProjectById = (id) => store((state) => state.data.projects.find((project) => project.id === id));
export const selectSelectedProject = () => store((state) => state.selected);
export const selectFetchedProject = () => store((state) => state.project.data);
export const selectProjectConfigurationById = (configId) => store((state) => state.project.data?.configurations?.find((config) => config.id === configId));
export const selectUnits = () => store((state) => state.project.units);
export const selectPaymentPlans = () => store((state) => state.paymentPlansNew);
export const selectPublicPaymentPlans = () => store((state) => state.publicPaymentPlansNew);
export const selectIsStoredPaymentPlan = (planId) => store((state) => Boolean(state.paymentPlansNew.find((plan) => plan.id === planId)));
export const selectPaymentPlanStage = (planItemIndex, groupIndex) => store((state) => state.paymentPlansNew?.[planItemIndex]?.groups?.[groupIndex]);
export const selectUnitPriceHistory = (unitId) => store((state) => state.unitsPriceHistory[unitId]);
export const selectUnit = (unitId) => store((state) => state.project.units.find((unit) => unit.id === unitId));
export const selectTransactionsTable = () => store((state) => state.transactionsTable);
export default {
    setSelected: store.getState().setSelected,
    addProject: store.getState().addProject,
    removeProject: store.getState().removeProject,
    getMapProjects: store.getState().getMapProjects,
    getListProjects: store.getState().getListProjects,
    getShortProjects: store.getState().getShortProjects,
    getProject: store.getState().getProject,
    createProject: store.getState().createProject,
    editProject: store.getState().editProject,
    deleteProject: store.getState().deleteProject,
    addToFavorite: store.getState().addToFavorite,
    deleteFromFavorite: store.getState().deleteFromFavorite,
    checkNumberAvailability: store.getState().checkNumberAvailability,
    getProjectUnits: store.getState().getProjectUnits,
    clearProjectUnits: store.getState().clearProjectUnits,
    uploadProjectUnits: store.getState().uploadProjectUnits,
    unitsScan: store.getState().unitsScan,
    updateRealUnitsCheckDate: store.getState().updateRealUnitsCheckDate,
    resetUnitsPriceHistory: store.getState().resetUnitsPriceHistory,
    updateTypicalUnitsCheckDate: store.getState().updateTypicalUnitsCheckDate,
    sendPhoneNumberViewAnalytics: store.getState().sendPhoneNumberViewAnalytics,
    syncProjectsWithDld: store.getState().syncProjectsWithDld,
    getDldProjectNumbers: store.getState().getDldProjectNumbers,
    syncProjectUnits: store.getState().syncProjectUnits,
    downloadUnits: store.getState().downloadUnits,
    createPaymentPlan: store.getState().createPaymentPlan,
    editPaymentPlan: store.getState().editPaymentPlan,
    copyPaymentPlan: store.getState().copyPaymentPlan,
    deletePaymentPlan: store.getState().deletePaymentPlan,
    createPaymentPlanItem: store.getState().createPaymentPlanItem,
    editPaymentPlanItem: store.getState().editPaymentPlanItem,
    deletePaymentPlanItem: store.getState().deletePaymentPlanItem,
    syncProjectPaymentPlans: store.getState().syncProjectPaymentPlans,
    getPaymentPlans: store.getState().getPaymentPlans,
    getPublicPaymentPlans: store.getState().getPublicPaymentPlans,
    syncPaymentPlans: store.getState().syncPaymentPlans,
    copyPaymentPlans: store.getState().copyPaymentPlans,
    syncProjectFinishes: store.getState().syncProjectFinishes,
    syncAmenities: store.getState().syncAmenities,
    getUnitPriceHistory: store.getState().getUnitPriceHistory,
    getUnitContacts: store.getState().getUnitContacts,
    sendUnitContactMetrics: store.getState().sendUnitContactMetrics,
    sendProjectViewMetrics: store.getState().sendProjectViewMetrics,
    sendProjectContactMetrics: store.getState().sendProjectContactMetrics,
    getConfigurations: store.getState().getConfigurations,
    createConfigurations: store.getState().createConfigurations,
    editConfigurations: store.getState().editConfigurations,
    deleteConfigurations: store.getState().deleteConfigurations,
    deleteUnitsPlans: store.getState().deleteUnitsPlans,
    deleteUnitsStubBatch: store.getState().deleteUnitsStubBatch,
    deleteUnitsStubAll: store.getState().deleteUnitsStubAll,
    deleteSoldOutUnit: store.getState().deleteSoldOutUnit,
    getTransactionsStats: store.getState().getTransactionsStats,
    getTransactionsSummary: store.getState().getTransactionsSummary,
    getTransactions: store.getState().getTransactions,
    createVideoLinks: store.getState().createVideoLinks,
    editVideoLinks: store.getState().editVideoLinks,
    sortVideoLinks: store.getState().sortVideoLinks,
    deleteVideoLinks: store.getState().deleteVideoLinks,
};
